import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _c9442b64 = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _0684e374 = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _2378f869 = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _5cbda095 = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _7c1add35 = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _a2a458be = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _13753ec2 = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _8698a48c = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _7b1f8fc3 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _4f7319e4 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _9fad6890 = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _593891d8 = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _5a8997b5 = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _b31a3326 = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _35d1ce18 = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _5f85eeff = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _642d4916 = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _518de246 = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _52d131a6 = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _5a89311f = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _62079ddd = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _b2cd765e = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _875caa08 = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _2670a4c2 = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _63008fa3 = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _ad200806 = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _4f94651b = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _8f61dda6 = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _51680764 = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _959efbae = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _314c7e00 = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _5a188ab8 = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _c070d10c = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _1a4c002a = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _09628d45 = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _ed5483ce = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _57b7b685 = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _5f5892cb = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _18fc0b6a = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _74333097 = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _00b39948 = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _3a9f2a36 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _688906b0 = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _2a98b398 = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _11ed3c44 = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _9bc5ac10 = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _68301b00 = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _7ad06ef4 = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _9fcbb30a = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _fc7e4a7a = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _e271d588 = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _4fec8b2e = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _df6c933e = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _2f133474 = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _61c64ec6 = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _299605a2 = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _5e93f5fa = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _6cdcadee = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _0aec87d2 = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _13d6d9a5 = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _1c3bff30 = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _dd8c49c0 = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _8f65c626 = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _eb43af94 = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _668c0111 = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _91580ede = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _57b8a8dd = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _ac76b22a = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _0686dc20 = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _7de4f264 = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _087e24a2 = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _3620e4e0 = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _22d354e8 = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _be1dab80 = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _c9442b64,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _0684e374,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _2378f869,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _5cbda095,
    name: "calendar"
  }, {
    path: "/customer",
    component: _7c1add35,
    name: "customer"
  }, {
    path: "/details",
    component: _a2a458be,
    name: "details"
  }, {
    path: "/goals",
    component: _13753ec2,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _8698a48c,
    name: "maisoku"
  }, {
    path: "/media",
    component: _7b1f8fc3,
    name: "media"
  }, {
    path: "/privacy",
    component: _4f7319e4,
    name: "privacy"
  }, {
    path: "/project",
    component: _9fad6890,
    name: "project"
  }, {
    path: "/response",
    component: _593891d8,
    name: "response"
  }, {
    path: "/achievement/output",
    component: _5a8997b5,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _b31a3326,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _35d1ce18,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _5f85eeff,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _642d4916,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _518de246,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _52d131a6,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _5a89311f,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _62079ddd,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _b2cd765e,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _875caa08,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _2670a4c2,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _63008fa3,
    name: "response-registration"
  }, {
    path: "/setting/announcement",
    component: _ad200806,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _4f94651b,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _8f61dda6,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _51680764,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _959efbae,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _314c7e00,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _5a188ab8,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _c070d10c,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _1a4c002a,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _09628d45,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _ed5483ce,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _57b7b685,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _5f5892cb,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _18fc0b6a,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _74333097,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _00b39948,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _3a9f2a36,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _688906b0,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _2a98b398,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _11ed3c44,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _9bc5ac10,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _68301b00,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _7ad06ef4,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _9fcbb30a,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _fc7e4a7a,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _e271d588,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _4fec8b2e,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _df6c933e,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _2f133474,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _61c64ec6,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _299605a2,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _5e93f5fa,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _6cdcadee,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _0aec87d2,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _13d6d9a5,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _1c3bff30,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _dd8c49c0,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _8f65c626,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _eb43af94,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _668c0111,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _91580ede,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _57b8a8dd,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _ac76b22a,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _0686dc20,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _7de4f264,
    name: "property-property",
    children: [{
      path: "contact",
      component: _087e24a2,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _3620e4e0,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _22d354e8,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _be1dab80,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
